// @ts-nocheck
import get from 'lodash.get';
import JsonApi from 'utils/jsonApi';
import type {
  RoiCalculatorResponse,
  PostRoiCalculatorData,
  RoiCalculatorRawResponse,
} from 'commons/types';

const parseRoiCalculatorResponse = (response: RoiCalculatorRawResponse): RoiCalculatorResponse => {
  const gradSchoolRoi = get(response, 'entities.gradSchoolRoi.undefined', {});
  const { hasCalculator, debtToEarnings, netAdvantageDegree, finance, program, salary } =
    gradSchoolRoi;
  const { estimatedLoanPayment } = finance;
  delete finance.estimatedLoanPayment;
  return {
    hasCalculator,
    debtToEarnings,
    netAdvantageDegree,
    estimatedLoanPayment,
    roiCalculatorData: { ...finance, ...program, ...salary },
  };
};

export default class RoiCalculator {
  jsonApi: JsonApi;

  constructor(jsonApi: JsonApi) {
    this.jsonApi = jsonApi;
  }

  async getDefaultDataBySchoolId(schoolId: string): Promise<RoiCalculatorResponse> {
    const response = await this.jsonApi.get(`/grad_schools/${schoolId}/roi`);
    const roiCalculatorData = parseRoiCalculatorResponse(response);
    return roiCalculatorData;
  }

  async postRoiCalculatorData({
    schoolId,
    roiCalculatorData,
  }: PostRoiCalculatorData): Promise<RoiCalculatorResponse> {
    const payload = {
      attributes: roiCalculatorData,
    };
    const url = `/grad_schools/${schoolId}/roi`;
    const response = await this.jsonApi.post(url, payload, false);
    const roiCalculatorDataResponse = parseRoiCalculatorResponse(response);
    return roiCalculatorDataResponse;
  }
}
